import SectionHeading from './SectionHeading';
import { hotRank } from '@/mocks/gossipData';

const maxScore = hotRank[0].score;
const rankBadge = (rank: number) => {
  if (rank <= 3) return 'bg-accent-500 text-background-50';
  return 'bg-secondary-200 text-secondary-900';
};

const hotSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: '昨日吃瓜热搜榜',
  numberOfItems: hotRank.length,
  itemListElement: hotRank.map((h, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: h.word,
  })),
};

export default function HotRanking() {
  return (
    <section id="hot" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(hotSchema) }} />
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading
          kicker="昨日热搜榜"
          title="昨日吃瓜热搜榜"
          accent="TOP 8"
          desc="按昨日全网讨论热度排序的热搜词条，点击话题可前往对应讨论区块。"
        />
        <p className="text-xs text-foreground-500 lg:pb-1">热度值：综合阅读与讨论估算 · 每晚 24:00 更新</p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2">
        {hotRank.map((item) => (
          <a
            key={item.rank}
            href="#essence"
            className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-200 hover:bg-secondary-50"
          >
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl font-heading text-base font-bold ${rankBadge(item.rank)}`}
            >
              {item.rank}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-heading text-[15px] font-bold text-foreground-950 group-hover:text-primary-700">{item.word}</h3>
                <span className="whitespace-nowrap rounded-md bg-primary-100 px-2 py-0.5 text-[11px] font-semibold text-primary-800">
                  {item.type}
                </span>
              </div>
              <div className="mt-2 flex items-center gap-3">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-secondary-100">
                  <div
                    className={`h-full rounded-full ${item.isLead ? 'bg-accent-500' : 'bg-primary-500'}`}
                    style={{ width: `${Math.max(18, (item.score / maxScore) * 100)}%` }}
                  />
                </div>
                <span className="whitespace-nowrap text-xs font-semibold text-foreground-600">{item.score.toLocaleString('zh-CN')}</span>
              </div>
            </div>
            <i className="ri-arrow-right-s-line text-xl text-secondary-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
          </a>
        ))}
      </div>
    </section>
  );
}